<template>
    <main>
        <section class="hero">
            <div class="tw-flex tw-flex-col tw-items-start tw-justify-items-center lg:tw-flex-row lg:tw-items-start lg:tw-justify-between lg:tw-gap-10">
                <div class="info-container tw-flex tw-flex-col tw-items-start tw-justify-start">
                    <img src="~@/assets/img/logo.svg" class="logo" alt="GoldFinance">
                    <p>Junte os seus empréstimos num só</p>
                    <h1>Reduza até 60%</h1>
                    <h2>as suas prestações<br>mensais</h2>
                </div>
                <div class="form-container">
                    <Form v-if="!$store.state.formSuccess && !$store.state.formError" />
                    <FormSuccess v-if="$store.state.formSuccess && !$store.state.formError" />
                    <FormError v-if="!$store.state.formSuccess && $store.state.formError" />
                </div>
            </div>
        </section>
        <section class="credit">
            <div class="tw-container">
                <div class="tw-flex tw-flex-col tw-gap-5 lg:tw-flex-row lg:tw-justify-between lg:tw-items-start lg:tw-gap-10 xl:tw-gap-20">
                    <div>
                        <h2>Crédito Consolidado</h2>
                        <p>
                            A <b>consolidação de todos os créditos</b> é uma solução eficaz para reduzir os encargos mensais realizando uma poupança significativa no orçamento familiar.
                        </p>
                        <p>
                            Analisamos todos os seus créditos e criamos um só, com melhores condições e uma taxa mais baixa.
                        </p>
                        <p>
                            Em vez de várias prestações passa a pagar uma única, mais baixa do que a média de todas as prestações que tinha anteriormente. As suas prestações mensais podem <b>reduzir-se em até 60%</b>.
                        </p>
                        <p class="tw-pb-4">
                            Temos uma equipa especializada que irá acompanhá-lo durante todo o processo e aconselhar a melhor solução para si. A nossa avaliação e aconselhamento não tem qualquer custo para o cliente.
                        </p>
                        <button class="btn-cta tw-block tw-mx-auto lg:tw-mx-0" v-scroll-to="'.form'">
                            Simule grátis
                        </button>
                    </div>
                    <div>
                        <div class="title">
                            <h3>Exemplo de poupança</h3>
                        </div>
                        <ul>
                            <li>
                                <div class="icon">
                                    <img src="~@/assets/img/icons/car.svg">
                                </div>
                                <div class="text">
                                    <p>Crédito Automóvel</p>
                                    <span>225€</span>
                                </div>
                            </li>
                            <li>
                                <div class="icon">
                                    <img src="~@/assets/img/icons/plane.svg">
                                </div>
                                <div class="text">
                                    <p>Crédito Pessoal</p>
                                    <span>320€</span>
                                </div>
                            </li>
                            <li>
                                <div class="icon">
                                    <img src="~@/assets/img/icons/card.svg">
                                </div>
                                <div class="text">
                                    <p>Outros Créditos</p>
                                    <span>150€</span>
                                </div>
                            </li>
                            <hr>
                            <li>
                                <div>
                                    <h5>TOTAL</h5>
                                </div>
                                <div>
                                    <p>Antes</p>
                                    <img src="~@/assets/img/before.svg" alt="695€">
                                </div>
                                <div>
                                    <p>Depois</p>
                                    <span>
                                        290€
                                    </span>
                                </div>
                            </li>
                        </ul>
                        <div class="savings">
                            <h4>POUPA 405€ mês</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="cert">
            <div class="tw-container tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-5 lg:tw-flex-row lg:tw-items-center lg:tw-gap-10">
                <img src="~@/assets/img/cert.png">
                <p>
                    Somos certificados pela scoring.pt como uma das melhores pequenas e médias empresas de Portugal no desempenho operacional e solidez financeira.
                </p>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
import FormError from '@/components/FormError.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
        FormError,
    },
};
</script>
